<template>
  <svg id="gevel" viewBox="-5 -5 75 75">
    <path
      d="M41.6,24h8.1v8.1h-8.1V24z M52.3,24h8.1v8.1h-8.1V24z M41.6,13.3h8.1v8.1h-8.1V13.3z M52.3,13.3h8.1v8.1h-8.1
                V13.3z M39.1,34.7h24v-24h-24V34.7z"
    />
    <polygon
      points="51,44.7 18.3,44.7 24.8,37.5 22.9,35.7 13.7,46 22.9,56.3 24.8,54.5 18.3,47.3 51,47.3"
    />
    <polygon points="0,0 0,64 2.6,64 2.6,2.6 64,2.6 64,0" />
    <rect x="5.8" y="6" width="2.6" height="58" />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconGevel extends Vue {}
</script>
